import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Site } from 'src/app/models/centrex/site';
import { OrganizationsService } from '../organizations.service';
import { ServiceBase } from '../service-base';

@Injectable({
    providedIn: 'root',
})
export class SiteService extends ServiceBase {
    constructor(private http: HttpClient, private organizationsServices: OrganizationsService) {
        super();
    }

    getSites(): Observable<Site[]> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<Site[]>(`${this.baseUrl}/api/sites`, httpOptions);
    }

    getSite(siteId: string): Observable<Site> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<Site>(`${this.baseUrl}/api/sites/${siteId}`, httpOptions);
    }

    addSite(site: Site, globalNotification = true): Observable<Site> {
        const httpOptions = {
            headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
                .set('global-notification', String(globalNotification))
                .set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.post<Site>(`${this.baseUrl}/api/sites`, site, httpOptions);
    }

    updateSite(site: Site): Observable<Site> {
        const httpOptions = {
            headers: new HttpHeaders().set('Content-Type', 'application/json').set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.patch<Site>(`${this.baseUrl}/api/sites/${site.id}`, site, httpOptions);
    }

    deleteSite(siteId: string) {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.delete<Site>(`${this.baseUrl}/api/sites/${siteId}`, httpOptions);
    }
}
